import { formatDate } from '../../shared';
import { ACCEPTED, ACTIVE, ENDED } from '../../shared/contractStatus';

// eslint-disable-next-line import/prefer-default-export
export const getContractDateToBeDisplayed = (intl, startingAt, cancelationDate, status) => {
  const contractHasProperCancellationDate =
    cancelationDate && new Date(cancelationDate) > new Date(startingAt);

  if ((status === ACTIVE || status === ENDED) && contractHasProperCancellationDate) {
    return {
      contractDateToBeDisplayedLabel: intl.formatMessage({ id: 'contract.status.title.end' }),
      contractDateToBeDisplayed: formatDate(cancelationDate),
    };
  }

  if (status === ACCEPTED) {
    return {
      contractDateToBeDisplayedLabel: intl.formatMessage({ id: 'contract.status.title.start' }),
      contractDateToBeDisplayed: formatDate(startingAt),
    };
  }

  return null;
};
